import { datadogRum } from '@datadog/browser-rum-slim';
import { isIgnoredNetworkError } from './ignoredNetworkErrors';

const shouldIgnore = (error: unknown): boolean =>
  error instanceof Error && isIgnoredNetworkError(error);

export const reportError = (error: unknown, errorContext?: Record<string, unknown>) => {
  const isDDEnabled = datadogRum.getInitConfiguration();

  if (errorContext) {
    console.error(error, errorContext);
  } else {
    console.error(error);
  }

  if (isDDEnabled && !shouldIgnore(error)) {
    datadogRum.addError(error, errorContext);
  }
};
